import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { Spin } from "antd";
import { getCultivarRecommendationReport } from "@services/api";
import GddBase from "@/components/reports/cultivar-recommendation/components/GddBase";
import ParameterBase from "@/components/reports/cultivar-recommendation/components/ParameterBase";

function CultivarRecommendationReport() {
  const { id } = useParams();

  const { isLoading, data } = useQuery({
    queryKey: ["cultivarRecomendationId", id],
    queryFn: () => getCultivarRecommendationReport(id),
  });

  const selectedRecommendation = data?.cultivarRecommendations?.find(
    (item) => item?.typeId
  );

  return (
    <>
      {isLoading ? (
        <div className="flex flex-row items-center w-[500px] h-[500px] mx-auto my-[6rem]">
          <Spin
            className="spiner-loading-farm-management"
            style={{ margin: "auto" }}
            size="large"
          />
        </div>
      ) : selectedRecommendation === 1 ? (
        <GddBase
          cultivarReport={data?.cultivarRecommendation}
          cultivarRecommendationsAnalysisResult={
            data?.cultivarRecommendationsAnalysisResult
          }
        />
      ) : (
        <ParameterBase
          cultivarReport={data?.cultivarRecommendation}
          cultivarRecommendationsAnalysisResult={
            data?.cultivarRecommendationsAnalysisResult
          }
        />
      )}
    </>
  );
}

export default CultivarRecommendationReport;
